import { render, staticRenderFns } from "./three-circle-model.vue?vue&type=template&id=6503e640&scoped=true&"
import script from "./three-circle-model.vue?vue&type=script&lang=js&"
export * from "./three-circle-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6503e640",
  null
  
)

export default component.exports